import styled from 'styled-components/macro';
import Checkbox from './checkbox';

const ToggleField = styled(({id, label, value, onChange, className, disabled}) => (
    <div className={className}>
        <Checkbox id={id} value={value} onChange={onChange} disabled={disabled} />
        <label htmlFor={id} dangerouslySetInnerHTML={{__html: label}} />
    </div>
))`
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
  align-items: center;
  label {
    padding-top: 1px;
    margin-left: 12px;
    font-weight: 500;
  }
`;

export default ToggleField;
